/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionRemotePatientSearchFieldMap
 */
export interface PalAuthSubmissionRemotePatientSearchFieldMap {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionRemotePatientSearchFieldMap
     */
    member_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionRemotePatientSearchFieldMap
     */
    member_last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionRemotePatientSearchFieldMap
     */
    member_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionRemotePatientSearchFieldMap
     */
    member_dob?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionRemotePatientSearchFieldMap interface.
 */
export function instanceOfPalAuthSubmissionRemotePatientSearchFieldMap(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionRemotePatientSearchFieldMapFromJSON(json: any): PalAuthSubmissionRemotePatientSearchFieldMap {
    return PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionRemotePatientSearchFieldMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'member_number': !exists(json, 'member_number') ? undefined : json['member_number'],
        'member_last_name': !exists(json, 'member_last_name') ? undefined : json['member_last_name'],
        'member_first_name': !exists(json, 'member_first_name') ? undefined : json['member_first_name'],
        'member_dob': !exists(json, 'member_dob') ? undefined : json['member_dob'],
    };
}

export function PalAuthSubmissionRemotePatientSearchFieldMapToJSON(value?: PalAuthSubmissionRemotePatientSearchFieldMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'member_number': value.member_number,
        'member_last_name': value.member_last_name,
        'member_first_name': value.member_first_name,
        'member_dob': value.member_dob,
    };
}

